import { isEmpty } from '@/helpers/is';

const noop = () => null;

/**
 * validate is value not empty
 * @param {string} val
 * @returns {boolean}
 */
const required = (val) => !isEmpty(val);

/**
 * validate only numbers
 * @param {string} val
 * @returns {boolean}
 */
const numbers = (val) => /[0-9]+$/.test(val);

/**
 * validate only english characters
 * @param {string} val
 * @returns {boolean}
 */
const english = (val) => /[a-zA-Z]+$/.test(val);

/**
 * validate only hebrew characters
 * @param {string} val
 * @returns {boolean}
 */
const hebrew = (val) => /[\u0590-\u05FF]+$/.test(val);

/**
 * validate only characters
 * @param {string} val
 * @returns {boolean}
 */
const characters = (val) => english(val) || hebrew(val);

/**
 * validate israel mobile phone number
 * @param {string} val
 * @returns {boolean}
 */
const mobile = (val) => /^0(5[^7]|[2-4]|[8-9]|7[0-9])[0-9]{7}$/.test(val);

/**
 * validate email address
 * @param {string} val
 * @returns {boolean}
 */
const email = (val) => /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(val);

/**
 * validate israel id number
 * @param {string | number} val
 * @returns {boolean}
 */
const uid = (val) => {
  const id = String(val).trim();

  if (id.length !== 9 || Number.isNaN(id)) return false;

  return Array.from(id, Number).reduce((counter, digit, i) => {
    const step = digit * ((i % 2) + 1);
    return counter + (step > 9 ? step - 9 : step);
  }) % 10 === 0;
};

const validations = {
  required,
  mobile,
  email,
  uid,
  numbers,
  english,
  hebrew,
  characters,
};

/**
 * wrapper function for mantine form validation
 * @param {mixed} value
 * @param {function} func
 * @param {string} error
 * @returns {string | null}
 */
const validate = (value, data = {}) => { // (value, func = () => {}, error = null) => {
  let output = null;

  Object.keys(data).forEach((key) => {
    const error = data[key];
    const func = validations[key] || noop;

    // continue in case we already have output
    if (output) {
      return;
    }

    output = func(value) ? null : error;
  });

  return output;
};

export default validate;

export {
  numbers,
  english,
  hebrew,
  characters,
};
